import { InlineNotification } from '@carbon/react';
import { Route, useLocation, useRouteMatch, Switch } from 'react-router-dom';
import { useEntity } from '../hooks';
import { ShowEntityPage } from '../show/page';
import { DeDuplicateEntityPage } from '../deduplicate/page';

/**
 * The entity routes: the show page and its deduplication page, both fed by the
 * entity the URL names.
 * @return {JSX.Element} The matched entity page
 */
export function EntityPageEntryPoint() {
  const { path } = useRouteMatch();
  const location = useLocation();

  const [resource, id] = location.pathname.split('/').filter((el) => el);
  const entityHref = `/${resource}/${id}`;

  const { entity, loading, error, getEntity } = useEntity(entityHref);

  if (error)
    return <InlineNotification kind="error" title={error} lowContrast />;

  return (
    <Switch>
      <Route exact path={`${path}/`}>
        <ShowEntityPage
          entity={entity}
          loading={loading}
          getEntity={getEntity}
        />
      </Route>
      <Route exact path={`${path}/deduplication`}>
        <DeDuplicateEntityPage loading={loading} entity={entity} />
      </Route>
    </Switch>
  );
}
